import $ from 'jquery';
import {cardLoyalty, promoCode} from '../api/api';
import qs from '../../scripts/util/dom/qs';
import qsc from '../../scripts/util/dom/qsc';
import rmc from '../../scripts/util/dom/rmc';
import hc from '../../scripts/util/dom/hc';
import isElem from '../../scripts/util/dom/isElement';
import addClass from '../../scripts/util/dom/addClass';
import controller, {updateSum, updateDelivery} from './controller';
import {compose} from 'ramda';

const selectors = {
	amount: '.amount',
	form: '.js-promo-form',
	card: '.js-promo-card-form',
	promo: '.js-promo-code-form',
	calcDelivery: '.js-amount-calculation-delivery',
	calcGiftCard: '.js-amount-calculation-gift-card',
	giftCardBalance: '.js-gift-card-balance',
	deliverySum: '.js-delivery-sum',
	amountKey: '.amount__key',
	checkbox: '.js-present-box',
	button: {
		card: '.js-promo-card-button',
		promo: '.js-promo-code-button'
	},
	check: {
		card: '.js-promo-card-check',
		promo: '.js-promo-code-check'
	},
	submit: '.js-promo-button',
	show: '.js-promo-show',
	input: {
		promo: '.js-promo-code-input',
		card: '.js-promo-card-input'
	}
};
const classes = {
	bonus: 'amount__check_state_visible',
	cross: 'amount__check_state_cross',
	form: 'amount__promo-form_state_visible',
	error: 'field__input_state_error'
};

const validation = {
	promo: {
		data: {
			'msg-target': 'siblings/.field__error',
			'invalid-value-msg': 'Промокод введен некорректно',
			'empty-value-msg': 'Введите промокод'
		},
		pattern: '[0-9,.]'
	},
	card: {
		data: {
			'msg-target': 'siblings/.field__error',
			'invalid-value-msg': 'Номер карты введен некорректно',
			'empty-value-msg': 'Введите номер карты'
		}
	}
};

// const fromMain = qsc(selectors.form);
const card = qsc(selectors.card);
const promo = qsc(selectors.promo);
const cardCheck = qsc(selectors.check.card);
const promoCheck = qsc(selectors.check.promo);
const promoInput = qsc(selectors.input.promo);
const cardInput = qsc(selectors.input.card);

// const sendData = (form, input) => {
// 	const $name = input.attr('name');
// 	const $value = input.val();
// 	const type = form.data('method');
// 	const url = form.data('action');
// 	const data = {
// 		[$name]: $value
// 	};
//
// 	return $.when($.ajax( {type, url, data} ));
// }

const show = e => {
	const $target = $(e.target);
	const type = $target.data('form');
	const form = type === 'card' ? card() : promo();
	const prev = type === 'card' ? promo() : card();
	const visibleClass = classes.form;

	rmc(visibleClass, prev);
	addClass(visibleClass, form);
};

const setValidate = () => {
	$(promoInput()).data(validation.promo.data);
	$(cardInput()).data(validation.card.data);
};

const switchToCrossState = compose(addClass(classes.cross), rmc(classes.bonus));

const onSuccess = (type, form) => {
	const delay = 15000;
	const check = type === 'card' ? cardCheck : promoCheck;
	addClass(classes.bonus, check());
	form.removeClass(classes.form);

	setTimeout(compose(switchToCrossState, check), delay);
};

const onSubmit = e => {
	e.preventDefault();
	const $target = $(e.currentTarget);
	const $input = $target.find('input');
	const $name = $input.attr('name');
	const $val = $input.val();
	const type = $target.data('type');
	const $data = {
		[`${$name}`]: `${$val}`
	};
	let send = 0;

	if (type === 'card') {
		send = cardLoyalty($data);
	} else {
		send = promoCode($data);
	}

	send.then(
		() => onSuccess(type, $target),
		data => console.log(data)
	);
};

const reset = e => {
	const target = e.currentTarget;
	const fieldSelector = hc('amount__check_type_card', target)
		? `${selectors.card} input`
		: `${selectors.promo} input`;

	qs(fieldSelector).value = '';
	rmc(classes.cross, target);
};

const upadateDeliverySum = updateDelivery;

const upadateGiftSum = sum => {
	if (sum === 0) {
		return updateSum('gift', 0);
	}

	updateSum('gift', sum.replace(' ', ''));
};

const updatePrice = sum => {
	updateSum('price', sum);
};

const addGiftPack = e => {
	e.stopPropagation();
	const $target = $(e.currentTarget);
	const isChecked = $target.is(':checked');
	const value = $target.data('value');
	if (isChecked) {
		updateSum('giftPack', value);
	} else {
		updateSum('giftPack', 0);
	}
};

const render = () => {
	if (isElem(selectors.amount)) {
		controller();
		$(selectors.form).on('valid', onSubmit);
		$(selectors.show).on('click', show);
		promoCheck().addEventListener('click', reset);
		cardCheck().addEventListener('click', reset);
		$(selectors.checkbox).on('click', addGiftPack);
		setValidate();
	}
};

export {
	upadateDeliverySum,
	upadateGiftSum,
	updatePrice
};

export default render;





/** WEBPACK FOOTER **
 ** ./app/blocks/amount/amount.js
 **/